















































































import { Component, Vue } from 'vue-property-decorator';
import { NewUser } from "../types";
import AuthService from "../services/AuthService";

@Component({
    components: {
    },
})
export default class Register extends Vue {
    private user: NewUser = {
        first_name: '',
        last_name: '',
        email: '',
        password:  '',
        language: 'es',
        name: '',
        confirmationUrl: 'https://golagol.com/confirm'
    };
    private passwordConfirm = "";
    private acceptTerms = false;
    private authService = new AuthService();
    private errors: string[] = [];

    private languages = [
        {
            name: 'Español',
            value: 'es'
        }
    ];

    private selectedList = ['en','ur','ar'];

    private checkForm() {
        if (
            this.user.first_name &&
            this.user.last_name &&
            this.user.email &&
            this.user.password &&
            this.user.language &&
            this.user.name &&
            this.passwordConfirm &&
            this.passwordConfirm === this.user.password
        ) {
            return true;
        }

        this.errors = [];

        if (!this.user.first_name) {
            this.errors.push('El nombre es obligatorio.');
        }

        if (!this.user.last_name) {
            this.errors.push('El apellido es obligatorio.');
        }

        if (!this.user.email) {
            this.errors.push('El email es obligatorio.');
        }

        if (!this.user.password || !this.passwordConfirm) {
            this.errors.push('La contraseña es obligatoria.');
        }

        if (this.user.password !== this.passwordConfirm) {
            this.errors.push('Las contraseñas no coinciden');
        }

        if (!this.user.language) {
            this.errors.push('El idioma es obligatorio.');
        }

        if (!this.user.name) {
            this.errors.push('El nombre de usuario es obligatorio.');
        }

        if (!this.acceptTerms) {
            this.errors.push('Tienes que aceptar los términos y condiciones.');
        }

    }

    private async handleSubmit() {
        const formValid = this.checkForm();

        if (!formValid) {
            this.errors.forEach((error: string) => {
                (this as any).$notify({
                    group: 'errors',
                    title: 'Error',
                    text: error,
                    type: 'error',
                });
            });
            return
        }

        try {
            await this.authService.register(this.user);
            this.$router.push("/login")
        } catch (e) { }

    }
}
